interface HighlightedTextProps {
  text: string;
  highlightedText: string;
}

export function HighlightedText(props: HighlightedTextProps) {
  const { text, highlightedText } = props;
  const index = text.toLowerCase().indexOf(highlightedText.toLowerCase());

  if (index === -1) {
    return <>{text}</>;
  }

  return (
    <span>
      {text.substring(0, index)}
      <b>{text.substring(index, index + highlightedText.length)}</b>
      {text.substring(index + highlightedText.length)}
    </span>
  );
}
